import { render, staticRenderFns } from "./MissionProfileFooter.vue?vue&type=template&id=21c340ab&scoped=true&"
import script from "./MissionProfileFooter.vue?vue&type=script&lang=js&"
export * from "./MissionProfileFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c340ab",
  null
  
)

export default component.exports